import { render, staticRenderFns } from "./AffidavitFS.vue?vue&type=template&id=1784c1fa"
import script from "./AffidavitFS.vue?vue&type=script&lang=ts"
export * from "./AffidavitFS.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports